module.exports = __webpack_public_path__ + "img/building-06.07c574f0.jpg";